import 'twin.macro';
import Image from '@leuven2030/framework/Image/Image';
import PrismicText from '@leuven2030/framework/Prismic/PrismicText';

export const ContentQuoteQuery = ({ typeName }) => `
        ... on ${typeName}BodyQuote {
          type
          primary {
            text
            image {
              ... on _ImageLink {
                url
              }
            }
            name
            function
          }
        }
`;

const ContentQuote = ({
  data: { image, text, name, function: personFunction }
}) => {
  function getImageNode() {
    if (!image) {
      return <></>;
    }
    const imageProps = {
      src: image.url,
      imgixParams: { fit: 'facearea', facepad: 2 },
      width: 256,
      height: 256
    };

    return (
      <div tw="flex-shrink-0">
        <Image tw="h-12 w-12 md:(h-20 w-20) rounded-full" {...imageProps} />
      </div>
    );
  }

  return (
    <div tw="max-w-lg mx-auto bg-white shadow p-6 overflow-hidden">
      <div tw="relative  flex-1">
        <svg
          tw="absolute top-0 left-0 transform -translate-x-8 -translate-y-12 h-24 w-24 text-gray-300 opacity-50"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 144 144"
          aria-hidden="true"
        >
          <path
            strokeWidth={2}
            d="M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z"
          />
        </svg>
        <blockquote tw="relative">
          <PrismicText tw="prose-sm max-w-full! text-justify" text={text} />
          <footer tw="mt-4">
            <div tw="flex space-x-3 items-center">
              {getImageNode()}
              <div tw="ml-4 lg:ml-0">
                <div tw="text-base font-medium text-gray-900">{name}</div>
                <div tw="text-sm font-medium text-primary-600">
                  {personFunction}
                </div>
              </div>
            </div>
          </footer>
        </blockquote>
      </div>
    </div>
  );
};

ContentQuote.type = 'quote';

export default ContentQuote;
